import { render, staticRenderFns } from "./ElmcoField.vue?vue&type=template&id=24399692&scoped=true"
import script from "./ElmcoField.vue?vue&type=script&lang=js"
export * from "./ElmcoField.vue?vue&type=script&lang=js"
import style0 from "./ElmcoField.vue?vue&type=style&index=0&id=24399692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24399692",
  null
  
)

export default component.exports